<p-toast [baseZIndex]="10000"></p-toast>

<p-confirmDialog [baseZIndex]="10000" rejectButtonStyleClass="p-button-text"></p-confirmDialog>

<div class="container-fluid" [@fadeIn]="true">

  @if (isLoading) {
    <p-progressSpinner class="mt-5 flex justify-content-center"></p-progressSpinner>
  } @else {
  <div class="row d-flex justify-content-center">
    <div class="col-10">
      <div class="row">
        <div class="col-1 mb-3">
          <p-button severity="secondary" type="button" icon="pi pi-undo" label="{{ 'Back' | translate }}" (click)="goBack()"></p-button>
        </div>
      </div>
      @if (!hasError) {
        <p-card header="{{ paymentDetailTitle }}">
          <hr class="mt-4">
          <!-- Detail -->
          @if(!showMemosList){
            <app-payment-form
              [entryFileDisable]="entryFileDisable"
              [isNewPayment]="false"
              [isSinglePayment]="true"
              [payment]="memoPayment"
              [showMemosList]="showMemosList"
              [cancelEnable]="cancelEnable"
              [reprocessableEnable]="reprocessableEnable"
              [sendBspLinkEnable]="sendBspLinkEnable"
              [rejectFileEnable]="rejectFileEnable"
              (getFileToDownloadMethod)="getFileToDownload($event)"
              (cancelPaymentAlertEvent)="cancelPaymentAlert()"
              (reprocessPaymentAlert)="reprocessPayment()"
              (updateStatusAlert)="updateStatus($event)"
              (showHideMemosListAlert)="showHideMemosList()"
              (viewTaskDetailAlert)="viewTaskDetail($event)"
            >
            </app-payment-form>
          } @else {
            <div class="table-container m-5">
              <h5 *ngIf="this.memoPayment.oMemosList !== null"> {{ 'MemoPayments.Total Amounts' | translate }}: {{ amountGroupedByCurrency }} </h5>
              <h5 *ngIf="this.memoPayment.oMemosList === null"> {{ 'MemoPayments.Empty File' | translate }} </h5>
              <hr class="mt-3 mb-5">

              <div class="row">
                <div class="col-12">
                  <p-tabs value="memoDocs">
                    <p-tablist>
                      <p-tab value="memoDocs"> {{ 'MemoPayments.List Memo Docs' | translate }} </p-tab>
                      <p-tab value="relatedDocs"> {{ 'MemoPayments.List Related Docs' | translate }} </p-tab>
                    </p-tablist>
                    <p-tabpanels>
                      <p-tabpanel value="memoDocs">
                        <div class="mt-3">
                          @if(isLoadingMemoList){
                            <p-progressSpinner class="mt-5 flex justify-content-center"></p-progressSpinner>
                          }
                              <p-table #memDoc [value]="memoDocs"
                                       [paginator]="true" [rows]="10" [rowsPerPageOptions]="[10,25,50]"
                                       [hidden]="isLoadingMemoList" class="table"
                                       [globalFilterFields]="[ 'document', 'agent', 'vat', 'amount', 'currency']">
                                <ng-template pTemplate="header">
                                  <tr class="header">
                                    <th pSortableColumn="document" translate> {{ 'MemoPayments.Memo Document' }}            <p-sortIcon field="document"> </p-sortIcon> </th>
                                    <th pSortableColumn="agent" translate>    {{ 'MemoPayments.Payee-Payer Agent' }}        <p-sortIcon field="agent">    </p-sortIcon> </th>
                                    <th pSortableColumn="vat" translate>      Vat                                           <p-sortIcon field="vat">      </p-sortIcon> </th>
                                    <th pSortableColumn="amount" translate>   Amount                                        <p-sortIcon field="amount">   </p-sortIcon> </th>
                                    <th pSortableColumn="currency" translate> Common.Currency                               <p-sortIcon field="currency"> </p-sortIcon> </th>
                                  </tr>
                                </ng-template>
                                <ng-template pTemplate="body" let-memoDocs>
                                  <tr>
                                    <td> {{ memoDocs.document }} </td>
                                    <td> {{ memoDocs.agent }} </td>
                                    <td> {{ memoDocs.vat }} </td>
                                    <td> {{ memoDocs.amount }} </td>
                                    <td> {{ memoDocs.currency }} </td>
                                  </tr>
                                </ng-template>
                                <ng-template pTemplate="emptymessage">
                                  <tr> <td colspan="9" translate>Table Commons.Not Found</td> </tr>
                                </ng-template>
                                <ng-template pTemplate="paginatorleft">
                                  <div class="row mt-4">
                                    <div class="p-field col-5">
                                      <p-floatlabel>
                                        <label for="over_label" translate><i class="pi pi-search ml-3"></i> Table Commons.Search Keyword </label>
                                        <input pInputText type="text" (input)="filterTableMemDoc($event.target.value)" [(ngModel)]="searchValueMemoDoc"/>
                                      </p-floatlabel>
                                    </div>
                                    <div class="col-4">
                                      <p-button severity="contrast" id="buttonClearCommissionedReportsList" label="{{ 'Table Commons.Clear Filter' | translate }}" icon="pi pi-filter-slash" (click)="clearMemoDoc(memDoc)"></p-button>
                                    </div>
                                  </div>
                                </ng-template>
                              </p-table>
                        </div>
                      </p-tabpanel>
                      <p-tabpanel value="relatedDocs">
                        <div class="mt-3">
                          @if(isLoadingRelatedList){
                            <p-progressSpinner class="mt-5 flex justify-content-center"></p-progressSpinner>
                          }

                          <p-table #relDoc [value]="relatedDocs"
                                   [paginator]="true" [rows]="10" [rowsPerPageOptions]="[10,25,50]"
                                   [hidden]="isLoadingRelatedList" class="table"
                                   [globalFilterFields]="[ 'document', 'relatedDoc', 'agent', 'relatedAmount', 'currency']">
                            <ng-template pTemplate="header">
                              <tr class="header">
                                <th pSortableColumn="document" translate> {{ 'MemoPayments.Memo Document' }} <p-sortIcon field="document"></p-sortIcon> </th>
                                <th pSortableColumn="relatedDoc" translate> {{ 'MemoPayments.Related Document' }} <p-sortIcon field="relatedDoc"></p-sortIcon> </th>
                                <th pSortableColumn="agent" translate> Agent <p-sortIcon field="agent"></p-sortIcon> </th>
                                <th pSortableColumn="relatedAmount" translate> {{ 'MemoPayments.Incentive Amount' }} <p-sortIcon field="relatedAmount"></p-sortIcon> </th>
                                <th pSortableColumn="currency" translate> Currency <p-sortIcon field="currency"></p-sortIcon> </th>
                              </tr>
                            </ng-template>
                            <ng-template pTemplate="body" let-relatedDocs>
                              <tr>
                                <td> {{ relatedDocs.document }} </td>
                                <td> {{ relatedDocs.relatedDoc}} </td>
                                <td> {{ relatedDocs.agent }} </td>
                                <td> {{ relatedDocs.relatedAmount }} </td>
                                <td> {{ relatedDocs.currency }} </td>
                              </tr>
                            </ng-template>
                            <ng-template pTemplate="emptymessage">
                              <tr> <td colspan="9" translate>Table Commons.Not Found</td> </tr>
                            </ng-template>

                            <ng-template pTemplate="paginatorleft">
                              <div class="row mt-4">
                                <div class="p-field col-5">
                                  <p-floatlabel>
                                    <label for="over_label" translate><i class="pi pi-search ml-3"></i> Table Commons.Search Keyword </label>
                                    <input pInputText type="text" (input)="filterTableRelDoc($event.target.value)" [(ngModel)]="searchValueRelatedDoc"/>
                                  </p-floatlabel>
                                </div>
                                <div class="col-4">
                                  <p-button severity="contrast" label="{{ 'Table Commons.Clear Filter' | translate }}" icon="pi pi-filter-slash" (click)="clearRelatedDoc(relDoc)"></p-button>
                                </div>
                              </div>
                            </ng-template>
                          </p-table>
                        </div>
                      </p-tabpanel>
                    </p-tabpanels>
                  </p-tabs>
                </div>
              </div>
              <div class="col-1 mt-4">
                <p-button type="button" severity="primary" class="m-auto" label="{{ 'View Payment Detail' | translate }}" icon="pi pi-undo" (click)="showHideMemosList()"></p-button>
              </div>
            </div>
          }
        </p-card>
      }
    </div>
  </div>
  }

</div>
